module.exports = __webpack_public_path__ + "static/img/aiHairColor.c0b34d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ai_beauty/aiHairColor.png
// module id = cyHD
// module chunks = 1